import { ExpandMoreRounded as ExpandMoreIcon } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material';
import { OrbitTrackLengthSlider } from './OrbitTrackLengthSlider';

export function GroundTrackOptions() {
  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        style={{
          flexDirection: 'row-reverse',
        }}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="inspector-panel-visual"
        id="inspector-panel-visual"
      >
        Ground Track
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          container
          px={2}
        >
          <OrbitTrackLengthSlider />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
